var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRefreshSquare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.5003 18.9577H7.50033C2.97533 18.9577 1.04199 17.0243 1.04199 12.4993V7.49935C1.04199 2.97435 2.97533 1.04102 7.50033 1.04102H12.5003C17.0253 1.04102 18.9587 2.97435 18.9587 7.49935V12.4993C18.9587 17.0243 17.0253 18.9577 12.5003 18.9577ZM7.50033 2.29102C3.65866 2.29102 2.29199 3.65768 2.29199 7.49935V12.4993C2.29199 16.341 3.65866 17.7077 7.50033 17.7077H12.5003C16.342 17.7077 17.7087 16.341 17.7087 12.4993V7.49935C17.7087 3.65768 16.342 2.29102 12.5003 2.29102H7.50033Z",
    fill: "#0B2233"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5837 9.99935C14.5837 12.5327 12.5337 14.5827 10.0003 14.5827C7.46699 14.5827 5.92531 12.0327 5.92531 12.0327M5.92531 12.0327H7.99199M5.92531 12.0327V14.3244M5.41699 9.99935C5.41699 7.46602 7.45033 5.41602 10.0003 5.41602C13.0587 5.41602 14.5837 7.96601 14.5837 7.96601M14.5837 7.96601V5.67435M14.5837 7.96601H12.5503",
    stroke: "#0B2233",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRefreshSquare);
export default __webpack_public_path__ + "static/media/refresh-square.9cfc8dd8176c3085a0dcd98d6b101596.svg";
export { ForwardRef as ReactComponent };